/**
 * inverse of getLdsStartDate, for the purpose of being able to approximate inputs from contactdb
 * Returns the number of months in the future that inputDate is from the current date.
 * mirrors the same functionality that LDS has in https://github.com/HigherEducation/gha-hxlds/blob/main/application/delivery-system/src/utils/getVoyagerValueFromStartDate.ts
 * @param {number | null | undefined} userInputValue - The date in YYYY-MM-DD format | null | undefined
 * @returns {string | null | undefined} - The number of months to add to the today's date | null | undefined
 */

const fromLdsStartDate = (userInputValue: string | null | undefined): number | null | undefined => {
  if (userInputValue === undefined || userInputValue === null) {
    return userInputValue as null | undefined;
  }
  const inputDate = new Date(userInputValue);
  if (Number.isNaN(inputDate.getTime())) {
    return null;
  }
  // because inputDate has no time component, we need to normalize the current date in the same way.
  const currentDate = new Date(new Date().toDateString());
  const diffMonths =
    (inputDate.getFullYear() - currentDate.getFullYear()) * 12 + (inputDate.getMonth() - currentDate.getMonth());
  return diffMonths;
};

export default fromLdsStartDate;
